import createSagaMiddleware from "redux-saga";
import { carMiddlewares, carReducers } from "@apac/cars";
import { flightsPriceFreezeRootReducer } from "@apac/components/flights-price-freeze";
import { disruptionRootReducer } from "@b2bportal/core-disruption";
import {
  flightRtkQueryReducers,
  flightsPostBookingApi,
  flightsRootReducer,
} from "@b2bportal/core-flights";
import {
  flightsRebookMiddleware,
  flightsRebookReducers,
} from "@b2bportal/core-flights-rebook";
import { hotelMiddlewares, hotelReducers } from "@b2bportal/core-hotels";
import { tripsRootReducer } from "@b2bportal/core-trips";
import { authReducer } from "@hopper-b2b/self-serve";
import { configureStore } from "@reduxjs/toolkit";
import {
  tenantFlightsMiddleware,
  tenantFlightsReducers,
} from "./tenantFlights";
import { travelerReducers, travelerMiddleware } from "./travelerStore";

const sagaMiddleware = createSagaMiddleware();
const middleware = [
  sagaMiddleware,
  ...tenantFlightsMiddleware,
  ...hotelMiddlewares,
  ...carMiddlewares,
  ...travelerMiddleware,
  ...flightsRebookMiddleware,
  flightsPostBookingApi.middleware,
];

const store = configureStore({
  reducer: {
    auth: authReducer,
    // FIXME: core-disruption has type errors

    // @ts-ignore
    disruption: disruptionRootReducer,
    flights: flightsRootReducer,
    trips: tripsRootReducer,
    ...hotelReducers,
    ...tenantFlightsReducers,
    ...travelerReducers,
    ...carReducers,
    ...flightsRebookReducers,
    flightsPriceFreeze: flightsPriceFreezeRootReducer,
    ...flightRtkQueryReducers,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
